module.exports = __webpack_public_path__ + "static/media/Layout27.f9c62143.png";